<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold" style="color:#04C1AB"></i>
            <i v-else class="el-icon-s-unfold" style="color:#04C1AB"></i>
        </div>
        <div class="logo">农合联金融服务平台</div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 用户头像 -->
                <div class="user-avator">
                    <img :src="userico" />
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{username}}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item divided command="editPassword">修改密码</el-dropdown-item>
                            <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
        <el-dialog title="修改密码" v-model="dialogFormVisible" :width="'600px'">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="用户名" :label-width="formLabelWidth">
                    <el-input disabled v-model="username"></el-input>
                </el-form-item>
                <el-form-item label="旧密码" :label-width="formLabelWidth" prop="oldPassword" required>
                    <el-input type="password" v-model="ruleForm.oldPassword" autocomplete="off" placeholder="请输入旧密码"></el-input>
                </el-form-item>
                <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPassword" required>
                    <el-input type="password" v-model="ruleForm.newPassword" autocomplete="off" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" :label-width="formLabelWidth" prop="newPassword2" required>
                    <el-input type="password" v-model="ruleForm.newPassword2" autocomplete="off" placeholder="请输入确认密码"></el-input>
                </el-form-item>
                <!-- <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item> -->
            </el-form>
            
            <template #footer>
                <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updatePassword">确 定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import apis  from "../api/index";
import md5 from 'js-md5';
export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请输入密码'));
            } else {
            if (this.ruleForm.oldPassword !== '') {
                this.$refs.ruleForm.validateField('oldPassword');
            }
            callback();
            }
        };
        var validatePass1 = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请输入密码'));
            } else {
            if (this.ruleForm.newPassword !== '') {
                this.$refs.ruleForm.validateField('newPassword');
            }
            callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.newPassword) {
            callback(new Error('两次输入密码不一致!'));
            } else {
            callback();
            }
        };
        return {
            dialogFormVisible: false,
            ruleForm: {
                oldPassword:'',
                newPassword: '',
                newPassword2: '',
            },
            rules: {
                oldPassword:[
                    { validator: validatePass, trigger: 'blur' }
                ],
                newPassword: [
                    { validator: validatePass1, trigger: 'blur' }
                ],
                newPassword2: [
                    { validator: validatePass2, trigger: 'blur' }
                ]
            },
            formLabelWidth: '120px',
        };
    },
    computed: {
        username() {
            let username = this.$store.state.username;
            return username ? username : '';
        },
        collapse() {
            return this.$store.state.collapse;
        },
        userico(){
            let userico = this.$store.state.userico;
            return userico ? userico : require('../assets/img/img.jpg');
        }
    },
    methods: {
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == "loginout") {
                this.$store.commit("clearMenus");
                localStorage.removeItem("user_info");
                localStorage.removeItem("routers");
                this.$store.commit("clearTags");
                this.$router.push("/login");
            }
            if (command == "editPassword") {
                this.dialogFormVisible = true;
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.$store.commit("hadndleCollapse", !this.collapse);
        },
        updatePassword(){
            let that = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if(localStorage.getItem("user_info")){
                        let userObj = JSON.parse(localStorage.getItem("user_info"))
                        let username = userObj.UserName;
                        let oldPassword = this.ruleForm.oldPassword;
                        let newPassword = this.ruleForm.newPassword;

                        let md5OldPassword = md5(oldPassword)
                        let md5NewPassword = md5(newPassword)
                        let para = {
                            userName : username,
                            oldPassword : md5OldPassword,
                            newPassword : md5NewPassword
                        }
                        apis.updateUserPassword(para).then(res => {
                            if(res === 1){
                                that.dialogFormVisible = false;
                                that.$message.success("修改密码成功,请重新登录");
                                localStorage.removeItem("user_info");
                                localStorage.removeItem("token");
                                that.$router.push("/login");
                            }else if(res === -2){
                                this.$message.error("用户名或者密码错误");
                            }else{
                                this.$message.error("修改密码失败");
                            }
                        }); 
                    }
                                       
                }
            });
        }
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
}
.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
}
.header .logo {
    text-indent: 60px;
    float: left;
    width: 550px;
    line-height: 70px;
    color:#04C1AB;
    background:url(../assets/img/logo1.png) no-repeat 0 10px;
    background-size: 50px 50px;
}
.header-right {
    float: right;
    padding-right: 30px;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}
.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}
.btn-bell .el-icon-bell {
    color: #fff;
}
.user-name {
    margin-left: 10px;
}
.user-avator {
    margin-left: 20px;
}
.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 20px;
}
.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}

.header >>> .el-input__inner { 
    width: 300px!important;
}
.header >>> .el-input__suffix {
    right: 144px;
}

</style>
